import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { Layout } from '@/shared/components/layout/Layout'
import { ProtectedRoute } from '@/shared/components/ProtectedRoute'
import { LoginForm } from '@/features/auth/components/LoginForm'
import { FileBrowser } from '@/features/files/components/FileBrowser'
import { UserAdmin } from '@/features/admin/components/UserAdmin'
import { RegistryTagAdmin } from '@/features/registry/components/RegistryTagAdmin'
import { DriveSection } from '@/features/devices/components/DriveSection'
import { SettingsPage } from '@/features/settings/components/SettingsPage'

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginForm />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <Layout>
                <Routes>
                  <Route path="/files/*" element={<FileBrowser />} />
                  <Route path="/drive" element={<DriveSection />} />
                  <Route path="/admin/site" element={<UserAdmin />} />
                  <Route path="/admin/tags" element={<RegistryTagAdmin />} />
                  <Route path="/settings" element={<SettingsPage />} />
                  <Route path="*" element={<Navigate to="/files" replace />} />
                </Routes>
              </Layout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  )
}
